<template>
  <div class="trending-sessions">
    <div class="container">
      <h2 v-if="false" class="heading">TRENDING</h2>

      <div class="sessions">
        <div class="row" v-if="loading">
          <div
            class="col-md-4 session"
            v-for="(session, n) in 9"
            :key="n"
          >
            <ArticleCardSkeleton :index="n" />
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div
              class="col-md-4 session"
              v-for="(session, n) in displaySessions"
              :key="n"
            >
              <session-card
                :session="session"
                :bookMarks="bookMarks"
                :followedBloggers="followedBloggers"
                :index="n"
                :show-ranking="false"
                @bookMarkBlog="bookMarkBlog"
                @followBlogger="followBlogger"
              />
            </div>
          </div>
          <div class="row pagination">
            <pagination
              v-if="totalPages > 1"
              :length="totalPages"
              @page-changed="changePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/other-pages/guides/Pagination";
import SessionCard from "@/components/other-pages/sessions/SessionCard";
import ArticleCardSkeleton from "@/components/other-pages/cornerLibrary/ArticleCardSkeleton";
export default {
  name: "TrendingSessions",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    sessions: {
      type: Array,
      default: () => {
        return []
      }
    },
    bookMarks: {
      type: Array,
      default: () => {
        return []
      }
    },
    followedBloggers: {
      type: Array,
      default: () => {
        return []
      }
    },
    resource: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      startInd: 0,
      perPage: 9
    };
  },
  components: {
    SessionCard,
    ArticleCardSkeleton,
    Pagination
  },
  computed: {
    totalPages() {
      return this.sessions
        ? Math.ceil(this.sessions.length / this.perPage)
        : 0;
    },
    displaySessions() {
      let endInd = this.startInd + this.perPage;
      let thisSessions = this.sessions.slice(this.startInd, endInd);
      this.$forceUpdate();
      return thisSessions;
    }
  },
  methods: {
    bookMarkBlog(data) {
      this.$emit("bookMarkBlog", data);
    },
    followBlogger(data) {
      this.$emit("followBlogger", data);
    },
    changePage(page) {
      console.log(`Page is ${page}`);
      this.startInd = (page - 1) * this.perPage;
      console.log(`Start Index ${this.startInd}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.trending-sessions {
  padding-top: 33px;
  padding-bottom: 40px;
  .heading {
    margin-left: 12px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    margin-bottom: 4px;
  }
  .sessions {
    .session {
      display: flex;
      justify-content: stretch;
      align-items: stretch;
      margin-bottom: 20px;
    }
  }
}
</style>
